<template>
  <header id="header">
    <div class="inner">
      <a href="#" class="image avatar">
        <img src="images/avatar.jpg" alt />
      </a>
      <h1>
        <strong>
          I am
          <router-link to="/">Toby</router-link>
        </strong>
        <span v-html="message"></span>
      </h1>
    </div>
    <Footer></Footer>
  </header>
</template>

<script>
import Footer from "./Footer.vue";

export default {
  data() {
    return {
      message:
        ",<br />working in Sydney 🦘,<br />originally from Karlsruhe 👶.",
      year: new Date().year,
      entries: [
        {
          url: "https://www.xing.com/profile/Tobias_Ruby",
          icon: "icon fa-xing",
          text: "XING"
        },
        {
          url: "https://www.linkedin.com/in/tobias-ruby",
          icon: "icon fa-linkedin",
          text: "LinkedIn"
        },
        {
          url: "https://www.instagram.com/tobiruby/",
          icon: "icon fa-instagram",
          text: "Instagram"
        },
        {
          url: "https://github.com/rubytobi",
          icon: "icon fa-github",
          text: "GitHub"
        },
        {
          url: "mailto:info@tobiasruby.de",
          icon: "icon fa-envelope-o",
          text: "Email"
        }
      ]
    };
  },
  components: {
    Footer
  }
};
</script>